import React, { useCallback } from 'react';
import type { ReactNode } from 'react';

import Button from '@atlaskit/button/new';

import { useFeedTypeSelector, FeedType } from '@confluence/feed/entry-points/useFeedTypeSelector';

type HTV2ViewPopularContentCTAProps = {
	children: ReactNode;
	onClick: () => void;
};

export const HTV2ViewPopularContentCTA = ({
	children,
	onClick,
}: HTV2ViewPopularContentCTAProps) => {
	const { feedType, updateFeedType } = useFeedTypeSelector();
	const handleFeedSelectorChange = useCallback(
		(updatedFeedType: FeedType | string) => {
			updateFeedType(updatedFeedType);
		},
		[updateFeedType],
	);

	const handleClick = useCallback(() => {
		// Update feed type if it is popular feed is not selected
		if (feedType !== FeedType.POPULAR) {
			handleFeedSelectorChange(FeedType.POPULAR);
		}
		// Mark the onboarding action card as completed
		onClick();
		// Scroll to the feed section
		const feedSection = document.querySelector('[data-testid="activity-feed"]');
		feedSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}, [feedType, handleFeedSelectorChange, onClick]);

	return (
		<Button onClick={handleClick} appearance="default">
			{children}
		</Button>
	);
};
